<template>
    <div class="ditu">
        <a-row style="height:98%">
            <a-col :span="24">
                <v-chart class="chart" :option="options" :ref="chart" :autoresize="true" @click="onMapClick"
                    style="padding-top:10px" />
            </a-col>
        </a-row>

    </div>
</template>

<script>
import http from '@/api/http';
import { defineComponent, ref, onMounted } from "vue";
import * as ECharts from 'echarts';
import henan from '@/map/henan.json';
ECharts.registerMap('henan', henan);
export default defineComponent({
    name: 'DiTu',
    components: {

    },
    setup() {

        let data = ref([]);

        let regions = [
            { name: '成都市', code: '510100' },
            { name: '自贡市', code: '510300' },
            { name: '攀枝花市', code: '510400' },
            { name: '泸州市', code: '510500' },
            { name: '德阳市', code: '510600' },
            { name: '绵阳市', code: '510700' },
            { name: '广元市', code: '510800' },
            { name: '遂宁市', code: '510900' },
            { name: '内江市', code: '511000' },
            { name: '乐山市', code: '511100' },
            { name: '南充市', code: '511300' },
            { name: '眉山市', code: '511400' },
            { name: '宜宾市', code: '511500' },
            { name: '广安市', code: '511600' },
            { name: '达州市', code: '511700' },
            { name: '雅安市', code: '511800' },
            { name: '巴中市', code: '511900' },
            { name: '资阳市', code: '512000' },
            { name: '阿坝藏族羌族自治州', code: '513200' },
            { name: '甘孜藏族自治州', code: '513300' },
            { name: '凉山彝族自治州', code: '513400' }
        ];
        const chart = ref(null);

        const options = ref({
            tooltip: {
                trigger: 'item',
                formatter: '{b}<br/>{c} (MWh)'
            },

            toolbox: {
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'center',

            },

            geo: {
                map: 'henan',
                roam: false,
                zoom: 1,
                label: {
                    show: false,
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        borderColor: '#00f6e7',
                        borderWidth: 4,
                        areaColor: 'rgba(65, 82, 245, 0)',
                        shadowColor: 'rgba(51, 69, 255, 1)',
                        shadowBlur: 20
                    },
                    emphasis: {
                        areaColor: 'rgba(0, 0, 0, 0)'
                    }
                },
                hoverAnimation: false,
                show: true,
            },
            series: [
                {
                    name: '河南地图',
                    type: 'map',
                    map: 'henan',
                    zoom: 1,
                    label: {
                        show: true,
                        textStyle: {
                            fontSize: 12,
                            color: '#62b0ea',
                        }
                    },

                    select: { // 地图选中区域样式
                        label: { // 选中区域的label(文字)样式
                            color: '#0c3d6e'
                        },
                        itemStyle: {// 选中区域的默认样式
                            areaColor: '#00ffec'
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderWidth: 1, //区域边框宽度
                            borderColor: '#50abef', //区域边框颜色
                            areaColor: "#0c3d6e", //区域颜色
                            borderType: 'dotted', //虚线
                        },
                        emphasis: {
                            borderWidth: 1,
                            borderColor: '#50abef',
                            areaColor: "#00ffec",
                        }
                    },
                    data: [],
                    // 自定义名称映射
                    nameMap: {}
                }
            ]
        });
        let code = 511800;
        const onMapClick = (e) => {

            console.log(e)

            regions.forEach(item => {
                if (item.name == e.name) {
                    code = item.code;
                }
            })

            const getData = () => {
                // http.get('api/visual/region/' + code).then(res => {

                //     let result = res.data.companys.map(item => {
                //         return item.name
                //     });
                //     data.value = result
                // })
            }
            getData();

        }

        const diqu = () => {
            // http.get("api/visual/region").then(res => {
            //     let shuliang = []
            //     res.data.map((item) => {
            //         shuliang.push({ value: item.volume, name: item.name });
            //     })
            //     options.value.series[0].data = shuliang
            // })

        }


        onMounted(() => { //组件挂载时的生命周期执行的方法
            const getData = () => {
                http.get('/base_station/province/1485').then(res => {


                    console.log(code, res)

                })

            }
            diqu();
            getData();
        });

        return {
            options, data, chart, onMapClick
        }
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ditu {
    height: calc(100vh - 220px);
}
</style>
